import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import * as Q from '../../../../constants/graphqlQueries';
import CustomDropdown from '../../../components/Dropdown/CustomDropdown';
import CustomButtons from '../../../components/Button/CustomButtons';
import CalloutBasic from '../../../Callout/Callout';
import colors from '../../../../constants/colors';

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
        },
      },
    },
  },
});
const useStyles = makeStyles(() => ({
  container: {
    padding: '0 14px 8px 14px',
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18)',
    borderRadius: '4px',
    textAlign: 'left',
    height: 'fit-content',
    background: '#ffffff'
  },
  title: {
    fontFamily: 'Segoe UI',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: colors.blue,
    marginTop: '8px',
    marginBottom: '4px',
    borderBottom: '1px solid rgba(0,0,0,0.08)',
    paddingBottom: '6px',
  },
  datePicker: {
    fontFamily: 'Segoe UI',
    fontSize: '1.4rem',
    display: 'block',
    marginTop: '6px',
  },
  dateLabel: {
    fontSize: '1.4rem',
    fontWeight: '500',
    color: '#263238',
    marginBottom: '3px',
    display: 'block',
  },
  rowFooter: {
    display: 'flex',
    marginBottom: '4px',
    marginTop: '8px',
    justifyContent: 'center',
    gap: '8px',
  },
}));
const defaultDropdownMessage = 'Select an option';


const Search = ({ onApplyClick, isDisabled, onClearSearch }) => {
  const classes = useStyles('');
  const [selectedClient, setSelectedClient] = useState();
  const [selectedDateRangePicker, setSelectedDateRangePicker] = useState();

  const [clients, setClients] = useState({});
  const [disabledButton] = useState(false);

  const { data: dataClients } = useQuery(Q.APP_ALERT_CLIENTS_GL_QUERY);

  const onClearClick = () => {
    setSelectedClient(null);
    setSelectedDateRangePicker(null);
    onClearSearch();
  }

  const onChangeClient = (client) => {
    if (client) {
      setSelectedClient(client);
    }
    else {
      setSelectedClient(null);
    }
  }

  const handleApply = () => {
    onApplyClick(selectedClient, selectedDateRangePicker);
  }



  // Fill client search field
  useEffect(() => {
    if (dataClients) {
      let clientsOptions = [];

      if (dataClients.getClients)
      {
        clientsOptions = [{ ClientId: defaultDropdownMessage, DescriptionShort: defaultDropdownMessage }, ...dataClients.getClients];

        const clientProps = {
          options: clientsOptions,
          getOptionLabel: (option) => option.ClientId === defaultDropdownMessage ? option.DescriptionShort : `${option.DescriptionShort} (${option.ClientId})`
        }

        setClients(clientProps);
      }
    }
  }, [dataClients]);

  const handleDateRangePicker = async (startDate, finishDate) => {
    setSelectedDateRangePicker([startDate, finishDate]);
  }

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.container}>
        <Box className={classes.title}>
          Filters
        </Box>
        <CustomDropdown
          title='Client'
          value={selectedClient}
          handleChange={onChangeClient}
          defaultProps={clients}
          disabled={isDisabled}
          selectedLabel={defaultDropdownMessage}
        />
        <div className={classes.datePicker}>
          <span className={classes.dateLabel}>Date</span>
          <CalloutBasic
            dateRange={selectedDateRangePicker}
            handleDateRangePicker={handleDateRangePicker}
          />
        </div>
        <Box className={classes.rowFooter}>
          <CustomButtons
            handleClick={onClearClick}
            name='Clear'
          />
          <CustomButtons
            handleClick={handleApply}
            name='Apply'
            disabled={disabledButton}
            tooltipFree
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

Search.propTypes = {
  onApplyClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClearSearch: PropTypes.func.isRequired
}

export default Search;